import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { VerificationLinkStateService } from './verification-link-state.service';
import { firstValueFrom } from 'rxjs';
const USER_KEY = 'auth-user';
const Ref_KEY = 'referesh-token-time';
const EMAIL_KEY = 'Email';
const RM_KEY = 'rememberMe';
const Route_Key = 'route';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  CurrentRoute: any;
  constructor(private router: Router,private verificationLinkStateService : VerificationLinkStateService) { }
  clean(): void {
    //window.sessionStorage.clear();
    //window.sessionStorage.removeItem(USER_KEY);
    localStorage.removeItem(USER_KEY);
  }

  removeLocalStorage(): void {
    localStorage.removeItem('selectedClientId');
    localStorage.removeItem('selectedClientName');
    localStorage.removeItem('selectedClientUserId');
    localStorage.removeItem('selectedEpName');
    localStorage.removeItem('supplierClientId');
    localStorage.removeItem('LoginUser');
    localStorage.removeItem('issupplierMultipleClient');    
  }

  public saveUser(user: any): void {
    // window.sessionStorage.removeItem(USER_KEY);
    // window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY,JSON.stringify(user));
  }

  public saveRefExpTime(refTime: any): void {
    localStorage.removeItem(Ref_KEY);
    localStorage.setItem(Ref_KEY,refTime);
  }

  public saveLogin(email: any,rememberMe: any,route : any): any {
    window.sessionStorage.removeItem(EMAIL_KEY);
    window.sessionStorage.setItem(EMAIL_KEY, email);
    window.sessionStorage.removeItem(RM_KEY);
    window.sessionStorage.setItem(RM_KEY, rememberMe);
    window.sessionStorage.removeItem(Route_Key);
    window.sessionStorage.setItem(Route_Key, route);
  }

  public removeLogin(): any {
    window.sessionStorage.removeItem(EMAIL_KEY);
    window.sessionStorage.removeItem(RM_KEY);
    window.sessionStorage.removeItem(Route_Key);
  }

  public getEmail(): any {
    const Email = window.sessionStorage.getItem(EMAIL_KEY);
    if (Email) {
      return Email;
    }

    return "";
  }

  public getRememberMe(): any {
    const RememberMe = window.sessionStorage.getItem(RM_KEY);
    if (RememberMe) {
      return RememberMe;
    }
    return "";
  }

  public getRoute(): any {
    const Route = window.sessionStorage.getItem(Route_Key);
    if (Route) {
      return Route;
    }
    return "";
  }


  public getUser(): any {
    const user =localStorage.getItem(USER_KEY); //window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  public getRefExpTime(): any {
    const expTime =localStorage.getItem(Ref_KEY);
    if (expTime) {
      return expTime;
    }

    return {};
  }

  public getUserToken(): string {
    const user = localStorage.getItem(USER_KEY);//window.sessionStorage.getItem(USER_KEY);
    if (user) {
      const userObject = JSON.parse(user);
      return userObject['token'] || '';
    }
    return '';
  }

  public getUserRefereshToken(): string {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      const userObject = JSON.parse(user);
      return userObject['refreshToken'] || '';
    }
    return '';
  }

  public getRefTokenExpTime(): Date {
    const refExp = localStorage.getItem(Ref_KEY);
    if (refExp) {
        return new Date(refExp);
    }
    return new Date(0);
}

  public isLoggedIn(): boolean {
    const user = localStorage.getItem(USER_KEY);//window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return true;
    }

    return false;
  }

  async GetUrl(): Promise<string> {
    await firstValueFrom(
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
    );
    return this.router.url;
}

  public reloadOnce() {
    if (!localStorage.getItem('forReload')) {
      localStorage.setItem('forReload', 'no reload')
      if (this.verificationLinkStateService.getMailVerified()) {
        localStorage.setItem('forReload', 'true');
      }
      location.reload();
    } else {
      const value = localStorage.getItem('forReload');
      if (value == "true") {
        this.verificationLinkStateService.setMailVerified(true);
      }
      localStorage.removeItem('forReload');
    }
  }

  public loginReload() {
    sessionStorage.setItem('fromLogin', 'true');
  }

  public veriReload() {
    sessionStorage.setItem('VeriReload', 'true');
  }

  public handleLoginReload(apiCallCallback: () => void): void {
    const fromLogin = sessionStorage.getItem('fromLogin');
    if (fromLogin === 'true') {
      sessionStorage.removeItem('fromLogin');
      location.reload();
    } else {
      apiCallCallback();
    }
  }

  public emailVeriReload(apiCallCallback: () => void): void {
    if (!sessionStorage.getItem('VeriReload')) {
      this.veriReload();
      location.reload();
    } else {
      sessionStorage.removeItem('VeriReload');
      apiCallCallback();
    }
  }
}
